import { senecColors } from "src/styles/senecBaseThemePalette";
import { SenecFPPTheme } from "src/styles/fpp-theme/theme.types";

export const senecMenuTheme = (theme: SenecFPPTheme) => {
    return {
        styleOverrides: {
            list: {
                padding: ".5rem",

                "& .MuiTablePagination-menuItem": {
                    ...theme.typography.body1Medium,
                    fontSize: "16px",
                    borderRadius: "4px",
                },
                "& .MuiTablePagination-menuItem.Mui-selected": {
                    backgroundColor: senecColors.deepBlue,
                    color: senecColors.white,
                    ...theme.typography.body1Medium,
                    fontSize: "16px",

                    "&:hover": {
                        backgroundColor: senecColors.neutralGray05,
                        color: senecColors.neutralGray110,
                    },
                },
            },
            paper: {
                borderRadius: "0.75rem",
            },
        },
    };
};
